module.exports = __webpack_public_path__ + "static/update-tweet-dialog.d268c092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forms/tutorial/update-tweet-dialog.png
// module id = 2541
// module chunks = 38899454822814